export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  count: number;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'drama',
    name: '剧情伦理',
    slug: 'drama',
    description: '以人物内心与道德抉择为核心，透过克制的叙事探讨良知、责任与自我认同的边界。',
    count: 3,
    icon: 'ri-film-line',
  },
  {
    id: 'romance',
    name: '爱情伦理',
    slug: 'romance',
    description: '聚焦亲密关系中的承诺、欲望与自由，呈现爱情在现实条件下的复杂面向。',
    count: 4,
    icon: 'ri-heart-3-line',
  },
  {
    id: 'society',
    name: '社会伦理',
    slug: 'society',
    description: '把镜头对准群体与制度，讨论正义、阶层与环境议题中普通人的两难处境。',
    count: 4,
    icon: 'ri-community-line',
  },
  {
    id: 'family',
    name: '家庭伦理',
    slug: 'family',
    description: '围绕血缘、代际与记忆展开，讲述家庭内部那些被刻意回避却始终存在的话题。',
    count: 3,
    icon: 'ri-home-heart-line',
  },
  {
    id: 'suspense',
    name: '悬疑伦理',
    slug: 'suspense',
    description: '在悬念与推理的外壳下追问真相与人性，让观众在解谜中思考道德的多重可能。',
    count: 2,
    icon: 'ri-question-mark',
  },
];

export const categoryNames: Record<string, string> = {
  drama: '剧情伦理',
  romance: '爱情伦理',
  society: '社会伦理',
  family: '家庭伦理',
  suspense: '悬疑伦理',
};